import debounce from 'lodash/debounce'
import * as React from 'react'
import {fromMaybe} from '@freckle/maybe'

import {
  type FetchDataParamsT,
  type FilterT
} from '@frontrow/console/src/components/common/data-table'
import {SchoolsDataTable} from '@frontrow/console/src/components/pages/schools-page/schools-data-table/schools-data-table'
import {useSchools} from '@frontrow/console/src/hooks/use-school'

type Props = {
  defaultFiltered: Array<FilterT>
}

export function SchoolsDataTableContainer(props: Props): React.ReactElement {
  const {defaultFiltered} = props
  const [fetchDataParams, setFetchDataParams] = React.useState<FetchDataParamsT | null>(null)

  const {schools, error, isLoading} = useSchools(fetchDataParams)

  const handleFetchSchools = debounce((params?: FetchDataParamsT | null) => {
    setFetchDataParams(params ?? null)
  }, 300)

  const schoolData = fromMaybe(() => [], schools)

  return (
    <SchoolsDataTable
      defaultFiltered={defaultFiltered}
      fetchSchools={handleFetchSchools}
      schoolData={schoolData}
      isLoading={isLoading}
      error={error ?? null}
    />
  )
}
